/*
 * @author Sergey Kuzhavskiy <Praffesor>
 */
const gccsSettingsManagers = {
  template: require('./template.pug'),
  controller: 'SettingsManagersController',
  controllerAs: 'settingsManagersCtrl',
  bindings: {
    editable: '<'
  }
};

angular.module('public.security-manager.settings').component('gccsSettingsManagers', gccsSettingsManagers);
